<template>
    <div>
        <div v-for="item in menuItems" :key="item.name">
            <b-list-group-item class="menu_vertical_parent" v-b-toggle="'id'+item.name" variant="light" activeClass="active" >
            <icon v-if="item.icon" :name="item.icon"></icon>
                <router-link style="color: black;" :to="item.link">{{item.name}}</router-link>
            </b-list-group-item>

            <b-collapse v-model="item.toggle" :id="'id'+item.name">
                <span v-if="item.children" >
                    <span v-for="child in item.children" :key="child.name">
                        <b-list-group-item activeClass="active" :to="child.link" exact class="menu_vertical_child">
                            <a>{{child.name}}</a>
                        </b-list-group-item>
                    </span>
                </span>
            </b-collapse>

        </div>
    </div>
</template>

<script>

  import {mixin} from '@/mixins/mixins';
  export default {
    mixins: [mixin],
    name: 'SettingsNavigation',
    data () {
      return {
        menuItems: [
            {name: 'General Settings', link:'/settings/hr/general', icon: 'cog', toggle: false},
            {name: 'Companies', link:'/settings/company/companies', icon: 'building', toggle: false},
            // {name: 'Divisions', link:'', icon: 'cog', toggle: false},
            {name: 'Branches', link:'/settings/company/branches', icon: 'list', toggle: false},
            {name: 'Departments', link:'/settings/company/departments', icon: 'address-book', toggle: false},
            {name: 'Designations', link:'/settings/company/designations', icon: 'briefcase', toggle: false},
            {name: 'Leave Types', link:'/settings/hr/leaves', icon: 'calendar', toggle: false},
            {name: 'Shift Categories', link:'/settings/hr/shift_categories', icon: 'cog', toggle: false},
            {name: 'Holidays List', link:'/settings/company/holidays', icon: 'plane', toggle: false},
            {name: 'Security / Permissions', link:'/settings/roles', icon: 'lock', toggle: false},

          // {name: 'Company Settings', link:'', icon: 'building', toggle: false, children: [
          //   {name: 'General Settings', link:'/settings/company/general', icon: ''},
          //   {name: 'Business Units', link:'/settings/company/units', icon: ''},
          //   {name: 'Company Locations', link:'/settings/company/locations', icon: ''},
          // ]},
          // {name: 'Billing & Subscriptions', link:'', icon: 'credit-card', toggle: false, children: [
          //   {name: 'Subscriptions', link:'/settings/subscriptions', icon: ''},
          //   {name: 'Payment Methods', link:'/settings/payment-methods', icon: ''},
          //   {name: 'Account Statement', link:'/settings/statement', icon: ''},
          // ]},
          // {name: 'Integration Settings', link:'', icon: 'plug', toggle: false, children: [
          //   {name: 'Marketplace Channels', link:'/settings/channels/marketplaces', icon: ''},
          //   {name: 'Email Channels', link:'/settings/channels/emails', icon: ''},
          //   {name: 'Fulfilment Systems', link:'/settings/channels/fulfilment', icon: ''},
          // ]},
          // {name: 'Helpdesk Settings', link:'', icon: 'cogs', toggle: false, children: [
          //   {name: 'Personal Settings', link:'/settings/helpdesk/personal', icon: ''},
          //   {name: 'Company Settings', link:'/settings/helpdesk/company', icon: ''},
          //   {name: 'Templates', link:'/settings/helpdesk/templates', icon: ''},
          //   {name: 'Snippets', link:'/settings/helpdesk/snippets', icon: ''},
          //   {name: 'Labels', link:'/settings/helpdesk/labels', icon: ''},
          //   {name: 'Workflows', link:'/settings/helpdesk/workflow', icon: ''},
          // ]},
        ],
      }
    },

    created() {
      return this.iShowCollapse(this.menuItems)
    },
    watch: {
      $route(to, from) {
        return this.iShowCollapse(this.menuItems)
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/settings/settings-navigation.vue